// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5875":"6a06a68e66997d74","6648":"c2e02cbcae6293ac","8773":"ac559569c72653a4"}[chunkId] + ".css";
};